import { UserAvailabilityOptions } from "@bezoned/shared/types/user-presence.js";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";

import { updateUserAvailabilityInFluid } from "../../../features/fluid/fluid.service.js";
import { useFluid } from "../../../features/fluid/hooks/use-fluid.js";
import { useLayoutStore } from "../../../store/layout.store.js";

export const KickedForInactivityModal = () => {
  const { hideModal } = useLayoutStore();
  const { fluidUserId, sharedTree } = useFluid();

  const handleRejoin = () => {
    updateUserAvailabilityInFluid({
      availability: UserAvailabilityOptions.Available,
      sharedTree,
      userId: fluidUserId,
    });
    hideModal();
    window.location.reload();
  };

  return (
    <Dialog modalType="alert" open={true}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>We have removed you from the office</DialogTitle>
          <DialogContent>
            You were removed from the office due to inactivity. You can rejoin
            the office by clicking the button below.
          </DialogContent>
          <DialogActions>
            <Button appearance="primary" onClick={handleRejoin}>
              Rejoin the office
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
